<template>
    <div class="why-micro">
        <h2 class="why-micro__title">{{this.title}}</h2>
        <p class="why-micro__block-description">Самый простой и удобный способ получить микрокредит – без залога</p>

        <ul class="why-micro__advantages">
            <li class="why-micro__advantage">
                <img src="@/assets/img/index/why-micro-1.svg" alt="" class="why-micro__advantage-icon">

                <div class="why-micro__text-wrap">
                    <p class="why-micro__advantage-title">Не выходя из дома</p>
                    <p class="why-micro__advantage-text">Подача заявки 100% онлайн 24/7 Решение через 30 минут</p>
                </div>
            </li>
            <li class="why-micro__advantage">
                <img src="@/assets/img/index/why-micro-2.svg" alt="" class="why-micro__advantage-icon">

                <div class="why-micro__text-wrap">
                    <p class="why-micro__advantage-title">Вся сумма в одном месте </p>
                    <p class="why-micro__advantage-text">Достаточно для серьёзных приобретений</p>
                </div>
            </li>
            <li class="why-micro__advantage">
                <img src="@/assets/img/index/why-micro-3.svg" alt="" class="why-micro__advantage-icon">

                <div class="why-micro__text-wrap">
                    <p class="why-micro__advantage-title">Минимальные требования</p>
                    <p class="why-micro__advantage-text">Удостоверение личности, интернет и мобильный телефон</p>
                </div>
            </li>
            <li class="why-micro__advantage">
                <img src="@/assets/img/index/why-micro-4.svg" alt="" class="why-micro__advantage-icon">

                <div class="why-micro__text-wrap">
                    <p class="why-micro__advantage-title">Без «сюрпризов»</p>
                    <p class="why-micro__advantage-text">Все суммы выплат известны заранее и не меняются
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "whyMicro",
	props: {
		title: {
			default: 'Почему Micro?'
		},
	},
	computed: {
		/*showProgressBar: function(){
			return this.$store.state.system.whyMicro;
		},*/
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";
@import "~@/assets/scss/site/desktop/index/why-micro";

@import "~@/assets/scss/site/mobile/index/why-micro";

</style>
